const ConvertCampaignObject = (obj) => {
  return Object.keys(obj).map((key) => obj[key]);
}

export {ConvertCampaignObject}